import { getWidgetSpecificIsVisible } from "@utils/index";
import React, { useContext, useEffect } from "react";
import { connect } from "react-redux";
import { desktopRightContainerWidth } from "@utils/index";
import { useOnload } from "@utils/useOnLoad";
import { Context } from "@components/useContext/context";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const BoxContainer = ({ children, ...props }: any) => {
  const { isDesktop } = useContext(Context);
  const {
    is_visible,
    styles,
    actions,
    wrapperStyles,
    mWrapperStyles = null,
    mStyles = null
  } = props;

  const { on_load } = actions || {};
  const mobileWrapperStyles = mWrapperStyles ? mWrapperStyles : wrapperStyles;
  const mobileStyles = mStyles ? mStyles : styles;
  useOnload({ on_load });

  return is_visible ? (
    <div
      className="form-container"
      {...props}
      style={isDesktop ? wrapperStyles : mobileWrapperStyles}
    >
      <div
        className="children-container"
        style={isDesktop ? styles : mobileStyles}
      >
        {children}
      </div>
      <style jsx>
        {`
          .form-container {
            padding: 32px;
            border-radius: 16px;
            border: 1px solid #efe9fb;
            background: #fff;
            width: ${desktopRightContainerWidth};
            height: max-content;
            overflow: visible;
            box-sizing: border-box;
            margin-bottom: 140px;
          }

          .children-container {
            width: 100%;
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            gap: 32px;
          }

          @media (max-width: 768px) {
            .form-container {
              border: unset;
              border-radius: 0px;
              padding: ${mStyles?.padding || '0px 20px 260px'};
              width: 100%;
              overflow: visible;
              margin-bottom: 0px;
            }
          }
        `}
      </style>
    </div>
  ) : (
    <></>
  );
};

export default connect(mapStateToProps)(BoxContainer);
